import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[ridOnly]'
})
export class RIDInputDirective {

  private regex: RegExp = new RegExp(/^\d+$/);
  private specialKeys: string[] = ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }

    const current = (event.target as HTMLInputElement).value;
    const next = current.concat(event.key);

    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const input = event.target as HTMLInputElement;
    const pastedText = event.clipboardData?.getData('text') ?? '';
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const next = input.value.slice(0, start) + pastedText + input.value.slice(end);

    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }
}